// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_ecf9a0d4","title":"_b170b287","icon":"_7622a8c"};